import { Injectable } from '@angular/core';
import { DefaultCoursesQuestionsService } from './default-courses-questions.service';
import { QuestionBase, DropdownQuestion, QuestionGroup, HiddenQuestion } from 'core/components/forms';
import { TranslateService } from '@ngx-translate/core';
import { ProfileService } from 'core/services/profile.service';
import { Profile } from 'core/models/agent';

@Injectable({
  providedIn: 'root'
})
export class ClientCoursesQuestionsService extends DefaultCoursesQuestionsService {
  user: Profile;
  constructor(protected translateService: TranslateService, protected profileService: ProfileService) {
    super(translateService, profileService);
    this.profileService.getLoggedUser$().subscribe((user) => (this.user = user));
  }

  public createSpecificQuestions(params: any = {}): QuestionBase<any>[] {
    return [this.getClientCourseConfigGroup(params), this.getCourseMeta(params)];
  }

  private getAccountsWithAccessQuestion(params: any = {}): QuestionBase<any> {
    const { course, clientId, disabledQuestion } = params;

    const question = new QuestionGroup({
      class: 'col-1',
      order: 5,
      childQuestions: [
        new HiddenQuestion({
          key: 'publish',
          value: course.publish
        })
      ]
    });

    if (course.clientId === clientId) {
      const clientIds =
        course.publish.clientIds && course.publish.clientIds.length ? course.publish.clientIds : [clientId];
      question.childQuestions.push(
        new DropdownQuestion({
          key: '_accountsSelection',
          label: 'courses.config.accountsWithAccess',
          class: 'col-1',
          value: clientIds.join(','),
          // placeholder: this.translate.instant('courses.config.clientsPublishModes.private', { account: course.clientName }),
          options: this.user.clients.map((cli) => ({
            key: cli.clientId,
            value: this.translateService.instant(cli.name),
            fixed: cli.clientId === clientId
          })),
          disabled: disabledQuestion,
          multiple: true,
          eventHandlers: {
            onChange: (value) => {
              const selection = this.formData._accountsSelection;
              const publish = {
                mode: selection && selection.length === 1 && selection.includes(clientId) ? 'private' : 'included',
                clientIds: selection,
                active: true
              };
              this.form.controls['publish'].setValue(publish);
            }
          }
        })
      );
    }
    return question;
  }

  /**
   * Get the Object for the CS form
   * @param params
   * @returns the course config for CS
   */
  private getClientCourseConfigGroup(params: any): QuestionGroup {
    const disabledQuestion = this.user.role === 'hr';
    const csCourseConfigGroup: QuestionGroup = new QuestionGroup({
      key: 'courseConfigIds',
      title: 'courses.config.title',
      isSection: true,
      isDropdown: false,
      isOpenCollapsible: false,
      hasHtml: true,
      order: 1,
      childQuestions: [
        this.getDiplomaQuestion({ ...params, disabledQuestion }),
        this.getAccessModeQuestion({
          ...params,
          disabledQuestion: !this.profileService.canExecute('courses.changeAccessMode')
        }),
        this.getAccountsWithAccessQuestion({ ...params, disabledQuestion })
      ]
        .filter((question) => question != null)
        .sort((a, b) => a.order - b.order)
    });

    return csCourseConfigGroup;
  }
}
